import { Stack, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { valueLimits } from "../../../../constants";
import { validateFloatNum } from "../../../../utils/common";

const DiscountPercentOffline = ({
  total,
  discount,
  final_payable,
  handleBlur,
  errors,
  touched,
  setFieldValue,
}: any) => {
  useEffect(() => {
    setFieldValue("final_payable", total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack direction={{ xs: "column", md: "row" }}>
      <TextField
        fullWidth
        id="discount"
        label="Discount (%)"
        size="small"
        value={discount}
        InputLabelProps={{
          required: true,
        }}
        sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
        disabled
      />
      <TextField
        fullWidth
        id="final_payable"
        label="Final payable amount"
        size="small"
        value={final_payable}
        onChange={(e: any) => {
          setFieldValue(
            "final_payable",
            validateFloatNum(e.target.value, valueLimits.MRP)
          );
          setFieldValue(
            "discount",
            validateFloatNum(
              Number((1 - e.target.value / total) * 100)?.toFixed(2),
              valueLimits.PERCENT
            )
          );
        }}
        onBlur={handleBlur}
        helperText={
          errors.final_payable && touched.final_payable
            ? errors.final_payable
            : ""
        }
        error={errors.final_payable && touched.final_payable ? true : false}
        sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
      />
    </Stack>
  );
};

export default DiscountPercentOffline;
